export const KeyboardKeys = {
  DOWN: 'ArrowDown',
  UP: 'ArrowUp',
  RIGHT: 'ArrowRight',
  LEFT: 'ArrowLeft',
  ESCAPE: 'Escape',
  ENTER: 'Enter',
  SPACE: ' ',
  TAB: 'Tab',
  END: 'End',
  HOME: 'Home',
  DELETE: 'Delete',
  PAGE_UP: 'PageUp',
  PAGE_DOWN: 'PageDown',
  BACKSPACE: 'Backspace',
  CLEAR: 'Clear',
};
